import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './LoadingState.styles';

export const LoadingState = () => {
  const { t } = useTranslation('widget');
  return (
    <S.LoadingStateRoot>
      <img
        src="/terminal/static/images/illustrations/summarising.svg"
        alt={t('widget:watchlist.loadingAlt')}
      />
      <S.Label>{t('widget:watchlist.loadingLabel')}</S.Label>
    </S.LoadingStateRoot>
  );
};
